//- A wrapper template for generating of a single row of the action list table
include mixins/action-list-row

+actionListRow(action)
